export const menu = {
    label: 'Templates',
    icon: 'pi pi-fw pi-copy',
    to: '/administracao/templates',
    rules: ['TEMPL-00'],
};
